import documentDefinitions from '../documentDefinitions';
import { captureException } from '../../util/logger';

/**
 * supportingInfo: [
 *  { type: <type>, title: <title>, url: <url>}
 * ]
 */
const addDocumentsToScores = (cow, scoreDefinitions) => {
  Object.keys(scoreDefinitions).forEach(scoreKey => {
    try {
      const score = scoreDefinitions[scoreKey];
      if (cow[score.category] && cow[score.category][scoreKey]) {
        cow[score.category][scoreKey].supportingInfo = [];
      }
    } catch (error) {
      captureException(error);
    }
  });
  if (cow.documents) {
    Object.keys(cow.documents).forEach(documentKey => {
      try {
        documentDefinitions[documentKey].scores.forEach(scoreKey => {
          const score = scoreDefinitions[scoreKey];
          const supportingInfo =
            cow[score.category][scoreKey].supportingInfo || [];
          supportingInfo.push({
            type: 'download',
            title: documentDefinitions[documentKey].name,
            url: cow.documents[documentKey].src
          });
          cow[score.category][scoreKey].supportingInfo = supportingInfo;
        });
      } catch (error) { /* */ }
    });
  }
};

export default addDocumentsToScores;
